<template>
  <div class="mirror-img">
    <custom-plane> </custom-plane>
  </div>
</template>

<script>
export default {};
</script>

<style>
.mirror-img {
  margin-top: 20px;
  width: 100%;
  height: 234.26px;
}
</style>
